import { render, staticRenderFns } from "./Salutation.vue?vue&type=template&id=ed4c6f22&scoped=true"
import script from "./Salutation.vue?vue&type=script&lang=js"
export * from "./Salutation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4c6f22",
  null
  
)

export default component.exports